import { Link } from "wouter";
import { MercuryAccountsCard } from "./ProfitAndLossTab";
import { useMercuryEligibility } from "./use-mercury-eligibility";
import { Skeleton } from "@/components/ui/skeleton";

export function BalanceTab() {
  const { allowed, loaded, failed } = useMercuryEligibility();
  if (failed) {
    return <div role="alert">Could not check balance access. Please reload this page.</div>;
  }
  if (!loaded) return <Skeleton className="h-32 w-full" data-testid="balance-access-loading" />;
  if (!allowed) {
    return (
      <div className="rounded-lg border bg-card p-6" data-testid="balance-unavailable">
        <h2 className="font-semibold">Balances unavailable</h2>
        <p className="mt-2 text-sm text-muted-foreground">Mercury balances require Financials access and an eligible plan.</p>
        <Link to="/app/billing" className="mt-3 inline-block text-brand underline">View billing</Link>
      </div>
    );
  }
  return <MercuryAccountsCard />;
}
